import './index.css'
import './i18n'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/App'
import { installDevGlobals } from './app/devtools'
import { installChunkLoadRecovery } from './lib/chunk-load-recovery'

const uninstallChunkLoadRecovery = installChunkLoadRecovery()
if (import.meta.hot) import.meta.hot.dispose(uninstallChunkLoadRecovery)
installDevGlobals()

interface BuildInfo {
  commit: string
  buildTime: string
  mode: string
}

declare global {
  interface Window {
    __BUILD_INFO__?: BuildInfo
  }
}

const buildInfo =
  window.__BUILD_INFO__
    ? window.__BUILD_INFO__
    : { commit: 'dev', buildTime: '', mode: 'development' }

console.info(
  '%c[Build]%c %s @ %s (%s)',
  'color:#1677ff;font-weight:bold',
  'color:inherit',
  buildInfo.commit,
  buildInfo.buildTime,
  buildInfo.mode,
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
